<template>
    <div class="af-pagination afu-flex afu-items-center afu-justify-center afu-my-3">
        <div class="afu-flex-1 afu-flex afu-justify-between sm:afu-hidden">
            <button
                type="button"
                class="af-pagination-item af-pagination-prev afu-relative afu-inline-flex afu-items-center afu-px-4 afu-py-2 afu-border afu-border-solid afu-border-gray-300 afu-text-sm afu-leading-5 afu-font-medium afu-rounded-md afu-text-gray-700 afu-bg-white hover:afu-text-gray-500 focus:afu-outline-none  focus:afu-border-primary-400 active:afu-bg-gray-100 active:afu-text-gray-700 afu-transition afu-ease-in-out afu-duration-150"
                @click.stop.prevent="prev()"
            >
                Previous
            </button>

            <button
                type="button"
                class="af-pagination-item af-pagination-next afu-ml-3 afu-relative afu-inline-flex afu-items-center afu-px-4 afu-py-2 afu-border afu-border-solid afu-border-gray-300 afu-text-sm afu-leading-5 afu-font-medium afu-rounded-md afu-text-gray-700 afu-bg-white hover:afu-text-gray-500 focus:afu-outline-none  focus:afu-border-primary-400 active:afu-bg-gray-100 active:afu-text-gray-700 afu-transition afu-ease-in-out afu-duration-150"
                @click.stop.prevent="next()"
            >
                Next
            </button>
        </div>

        <div class="af-pagination-item afu-hidden sm:afu-inline-flex afu-inline-flex">
            <C1PaginatorArrow
                :disabled="currentPage === 1"
                @click.stop.prevent="prev()"
            />

            <C1PaginatorPage
                v-for="(pg, index) in pagesRage"
                :key="index"
                :disabled="pg.disabled"
                :active="currentPage === pg.value"
                @click.stop.prevent="changePage(pg.value)"
            >
                {{ pg.value }}
            </C1PaginatorPage>

            <C1PaginatorArrow
                next
                :disabled="currentPage === totalPages"
                @click.stop.prevent="next()"
            />
        </div>
    </div>
</template>

<script>
    import C1PaginatorArrow from '@/components/C1Components/C1PaginatorArrow';
    import C1PaginatorPage from '@/components/C1Components/C1PaginatorPage';

    export default {
        name: 'C1Paginator',

        components: {
            C1PaginatorArrow,
            C1PaginatorPage,
        },

        props: {
            currentPage: {
                type: Number,
                default: 1,
            },

            perPage: {
                type: Number,
                default: 0,
            },

            total: {
                type: Number,
                default: 0,
            },

            limit: {
                type: Number,
                default: 3,
            },

            pageNumberLimit: {
                type: Number,
                default: 0,
            },

            nextLabel: {
                type: String,
                required: false,
                default: '',
            },

            previousLabel: {
                type: String,
                required: false,
                default: '',
            },
        },

        data() {
            return {

            };
        },

        computed: {
            totalPages() {
                const output = Math.ceil(this.total / this.perPage);

                // Fix the number of pages based on props
                if (this.pageNumberLimit && output > this.pageNumberLimit) {
                    return this.pageNumberLimit;
                }

                return output < 1 ? 1 : output;
            },

            pagesRage() {
                const total = this.totalPages;
                const range = [];
                const gap = this.limit;
                const before = this.currentPage - gap;
                const after = this.currentPage + gap;
                const pages = [];

                // eslint-disable-next-line
                for (let i = 1; i <= total; i++) {
                    if (i === 1 || i === total || (i >= before && i <= after)) {
                        range.push({
                            id: i,
                            value: i,
                            disabled: false,
                        });
                    }
                }

                range.forEach((item, index) => {
                    pages.push(item);

                    const nextIndex = index + 1;

                    if (nextIndex <= range.length - 1) {
                        if (item.id + 1 !== range[nextIndex].id) {
                            pages.push({
                                id: `${item.id}_ellipsis`,
                                value: '...',
                                disabled: true,
                            });
                        }
                    }
                });

                return pages;
            },

            currentPageObject() {
                const output = this.pagesRage.filter(o => o.id === this.currentPage);
                return output.length ? output[0] : {};
            },
        },

        methods: {
            changePage(page) {
                if (typeof page === 'number') {
                    this.$emit('change', page);
                }
            },

            prev() {
                if (this.currentPage !== 1) {
                    this.changePage(this.currentPageObject.id - 1);
                }
            },

            next() {
                if (this.currentPage < this.totalPages) {
                    this.changePage(this.currentPageObject.id + 1);
                }
            },
        },
    };
</script>

<style
    lang="scss"
    scoped
>
    .vue-pagination-item {
        align-items: center;
        display: flex;
        font-weight: normal;
        justify-content: center;
        margin: 0 2.5px;

        .vue-pagination-link {
            align-items: center;
            background-color: #fff;
            border: 1px solid #e4e5eb;
            border-radius: 6px;
            color: #69788a;
            display: flex;
            font-size: 16px;
            justify-content: center;
            line-height: 10px;
            min-height: 30px;
            min-width: 30px;
            padding: 15px 18px;
            text-decoration: none;

            &.vue-pagination-link-next,
            &.vue-pagination-link-prev {
                font-size: 14px;
                font-weight: bold;
                padding: 15px 18px;
                text-transform: uppercase;
            }
        }

        &.disabled {
            .vue-pagination-link {
                cursor: default;
                opacity: 0.5;
            }
        }

        &.is-active,
        &:hover:not(.disabled) {
            .vue-pagination-link {
                background-color: blue;
                border-color: blue;
                color: #fff;
                text-decoration: none;
            }
        }
    }
</style>
